import { render, staticRenderFns } from "./order-stat.vue?vue&type=template&id=0606971e&scoped=true"
import script from "./order-stat.vue?vue&type=script&lang=js"
export * from "./order-stat.vue?vue&type=script&lang=js"
import style0 from "./order-stat.vue?vue&type=style&index=0&id=0606971e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0606971e",
  null
  
)

export default component.exports